import { Box } from "@mui/material";
import React from "react";
import { KeyDrivePrimaryButton } from "../Buttons/KeyDrivePrimaryButton";
import { KeyDriveBodyMin } from "../Fonts/Body/KeyDriveBodyMin";

interface IEmptyContainerButton {
    text: string;
    icon: React.ReactNode;
    onClick: () => void;
}

interface IEmptyContainer {
    icon: React.ReactNode;
    needAction?: boolean;
    title: string;
    content: string;
    buttonProps?: IEmptyContainerButton;
}

export const EmptyContainer: React.FC<IEmptyContainer> = ({
    icon,
    content,
    title,
    needAction,
    buttonProps
}) => {
    return (
        <Box
            height="100%"
            minHeight="150px"
            width="100%"
            flexGrow={1}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            borderRadius="10px"
            border="1px solid #0000001A"
        >
            { icon }
            <Box mt="20px">
                <KeyDriveBodyMin
                    color="#2D2D2D"
                    needBold
                    needEllipses={false}
                    text={title}
                />
            </Box>
            <Box width={340} textAlign={"center"} mt="4px">
                <KeyDriveBodyMin
                    color="#2D2D2D96"
                    needBold={false}
                    needEllipses={false}
                    text={content}
                />
            </Box>
            { needAction && (
                <Box
                    mt="20px"
                >
                    <KeyDrivePrimaryButton
                        startIcon={buttonProps?.icon}
                        onClick={buttonProps?.onClick}
                        height="30px"
                        TextComponent={KeyDriveBodyMin}
                        TextComponentProps={{
                            color: "#FFFFFF",
                            needBold: false,
                            needEllipses: false,
                            text: buttonProps?.text!
                        }}
                    />
                </Box> 
            ) }
        </Box>
    )
}
